import React from 'react';

export default class Page3 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div align="center"><img style={{maxWidth: '100%'}}
                                                                     src={require('@images/ethical-decision1.png')}
                                                                     alt="image"/></div>

                                            <div className="circle_title"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>A GUIDE TO ETHICAL DECISIONS
                                            </div>
                                            <p>As you will have noted from the previous section, some
                                                approaches to ethical decision making
                                                are more appropriate in some situations than others.</p>
                                            <p>Clearly, making ethical decisions is no easy task. In our
                                                complex global business climate, there
                                                are many factors to consider before we can arrive at a
                                                decision that not only makes sound
                                                business sense but also gives careful consideration to what
                                                is morally and ethically ‘right’.</p>
                                            <p style={{paddingBottom: '9px'}}>The guide below will help you to
                                                make such decisions, and incorporates some of the key
                                                aspects
                                                of the five approaches illustrated above.</p>
                                            <span
                                                className="green font_span"><strong>Discover the problem</strong></span>
                                            <ul className="greenbullet-list botm-pad-zero space-pad"
                                                style={{paddingTop: '9px'}}>
                                                <li>Is there an ethical dimension to this decision?</li>
                                                <li>Is there a moral side to be considered?</li>
                                                <li style={{paddingBottom: '9px'}}>If so, who is this decision
                                                    going to impact on?
                                                </li>
                                            </ul>
                                            <span
                                                className="green font_span"><strong>Get the relevant info</strong></span>
                                            <ul className="greenbullet-list botm-pad-zero space-pad"
                                                style={{paddingTop: '9px'}}>
                                                <li>What are the relevant facts? What facts are unknown?
                                                </li>
                                                <li>Who is involved in your decision? Have you consulted
                                                    them?
                                                </li>
                                                <li style={{paddingBottom: '9px'}}>Is there a precedent for
                                                    this action that needs considering?
                                                </li>
                                            </ul>
                                            <span
                                                className="green font_span"><strong>Make your own judgement</strong></span>
                                            <ul className="greenbullet-list botm-pad-zero space-pad"
                                                style={{paddingTop: '9px'}}>
                                                <li>How do you feel about the issue?</li>
                                                <li style={{paddingBottom: '9px'}}>Do you have a ‘gut’ feeling
                                                    one way or the other that you think is valid?
                                                </li>

                                            </ul>
                                            <span className="green font_span"><strong>Take a decision and put your plan into action</strong></span>
                                            <ul className="greenbullet-list botm-pad-zero space-pad"
                                                style={{paddingTop: '9px'}}>
                                                <li>Having gathered the information you need, make your
                                                    decision.
                                                </li>
                                                <li>Draw up a plan of action that you can stick to.</li>
                                                <li style={{paddingBottom: '9px'}}>Be decisive; if it’s the
                                                    right thing to do, then you need to act accordingly with
                                                    confidence.
                                                </li>
                                            </ul>
                                            <div className="left-btn">
                                                <div onClick={this.props.handleChangePage('Page2')}
                                                     className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div onClick={this.props.handleChangePage('Page4')}
                                                     className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}